import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-clickCollectSelect",
  "use": "icon-clickCollectSelect-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol viewBox=\"0 0 20 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-clickCollectSelect\">\n<g id=\"icon-clickCollectSelect_frame\">\n<circle id=\"icon-clickCollectSelect_icon\" cx=\"10\" cy=\"10.5\" r=\"10\" fill=\"#2A7DE1\" />\n<circle id=\"icon-clickCollectSelect_icon-2\" cx=\"10\" cy=\"10.5\" r=\"4\" fill=\"white\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol